module.exports = __webpack_public_path__ + "static/media/medial-nonflexion-up-4.a5bf07f3.png";